module.exports = __webpack_public_path__ + "static/media/04.65620ff2.png";